// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_MesclarInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Chamados_MesclarInput — POST /chamados/mesclar.
 *
 * Vários chamados pequenos viram um só: `origens` são agrupados em `destino_id`.
 * O contrato só afirma a FORMA (ids positivos, distintos, destino fora da
 * lista). Se cada origem está em andamento e é do MESMO solicitante que o
 * destino depende das linhas do banco — essa metade é do controller.
 */
import { registerContract } from './validate'

export interface Chamados_MesclarInput {
destino_id: number
origens?: number[]
}

registerContract('Chamados_MesclarInput', {
  destino_id: { type: 'number',  required: true },
  origens:    { type: 'array',   required: false },
})
